import { render, staticRenderFns } from "./UpcomingFixturesTable.vue?vue&type=template&id=4df28e26&"
import script from "./UpcomingFixturesTable.vue?vue&type=script&lang=js&"
export * from "./UpcomingFixturesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports